<!-- 关于弘知 -->
<template>
  <div
    class="about"
    style="min-width: 1600px;"
  >
    <NavBar
      :navIndex="navIndexs"
      :imgHeight="482"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <!-- 关于弘知 -->
    <div style="position:relative;width: 100%;">
      <img
        src="../assets/about-bg.png"
        alt=""
        class="mod-section-ad"
      >
      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">走进弘知</div>
        <div class="slogan-subtitle">
          以匠心教人，用真情育人
        </div>
      </div>
    </div>
    <!-- 选择 -->
    <div style="display: flex;align-items: center;justify-content: center;">
      <div
        v-for="(item,index) in tabData"
        :key="index"
        class="select-tab"
        :class="item.status?'select-tab-true':'select-tab-false'"
        @click="selectContent(item.name,index)"
      >{{item.name}}
      </div>
    </div>

    <!-- 内容 -->
    <div class="content-big-box">
      <!-- 企业简介 -->

      <div style="background-color: #fff;width: 1200px;padding: 40px;box-sizing: border-box;">
        <contentTitle
          text='企业简介'
          style="margin-bottom: 30px;"
        />

        <!-- 描点跳转 -->
        <div
          id="企业简介"
          class="anchorPoint"
        ></div>
        <!-- 总体简介 -->
        <div class="df">
          <div>
            <div
              class="ff-pb"
              style="position:relative;font-size:26px;"
            >
              总体简介
              <div style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"></div>
            </div>
            <div style="margin-top: 20px;line-height: 30px;">
              湖南弘知教育科技有限公司是一家以教育培训、教育投资和运营管理为主营业务的高科技平台型教育服务企业，旗下拥有弘知培训学校、弘朗培训学校、弘之道培训学校、弘知教育咨询有限公司、隽朗科技有限公司、弘知商学院等多家子公司。弘知在K12教培领域深耕多年，具有强劲的竞争力。在线下教学服务质量获得良好口碑的同时，大力进行线上教育的研发，目前已有一系列线上教育产品面世。公司以弘知集团的成功管理经验为蓝本，开发出系统化的运营课程和信息化企业管理系统，致力于为相关行业提供完善的运营管理解决方案。公司坚持“依托教育、整合资源、打造品牌、提供价值”的方针，积极探索教育多元化发展之路，践行服务社会的责任，目前多个业务板块均在蓬勃发展。
            </div>
          </div>
          <img
            src="../assets/build2.jpeg"
            alt=""
            class="buildImg buildImg2"
          >
        </div>

        <div
          class="df"
          style="margin-top: 104px;"
        >
          <img
            src="../assets/build1.jpeg"
            alt=""
            class="buildImg buildImg1"
          >
          <div>
            <div
              class="ff-pb"
              style="position:relative;font-size:26px;"
            >
              企业文化
              <div
                class=""
                style="position:absolute;width: 30px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <!-- <div style="margin-top: 20px;line-height: 30px;">
              <p>
                <span class="ff-pb f19">弘知愿景</span>
                <br />弘扬知识 改变世界
              </p>
              <p> <span class="ff-pb f19">弘知宗旨</span>
                <br /> 经世致用 朴实求真
              </p>
              <p> <span class="ff-pb f19">教研理念</span>
                <br /> 专注对初高中每类学科知识的深入挖掘与精细剖析，力图将复杂的知识用最简单的方式呈现给学生
              </p>
              <p> <span class="ff-pb f19">教学理念</span>
                <br /> 训练学生思维，激发学生兴趣，改变学生学习观念，培养学生学习能力
              </p>
              <p> <span class="ff-pb f19">教师要求</span>
                <br /> 专选一流高校，专业成绩优良，专研一门学科，专注学生成长
              </p>
            </div> -->
            <p style="margin-top: 20px;line-height: 30px;">弘知愿景：弘扬知识 改变世界 <br />
              弘知宗旨：经世致用 朴实求真<br />
              弘知使命：学习知识，整理知识，探索知识，传承知识<br />
              教研理念：专注对初高中每类学科知识的深入挖掘与精细剖析，力图将复杂的知识用最简单的方式呈现给学生<br />
              教学理念：训练学生思维，激发学生兴趣，改变学生学习观念，培养学生学习能力<br />
              教师要求：专选一流高校，专业成绩优良，专研一门学科，专注学生成长</p>
          </div>
        </div>

      </div>

      <!-- 发展历程 -->

      <div style="width: 1200px;min-height:800px;">
        <div
          id="发展历程"
          class="anchorPoint"
        ></div>

        <contentTitle
          text='发展历程'
          style="margin: 30px 0 30px 0;"
        />
        <Timeline />
        <!-- <img
          style="width: 1200px;"
          src="../assets/about-history.png"
          alt=""
        > -->
      </div>

      <!-- 弘知校区 -->
      <div>
        <div
          id="弘知校区"
          class="anchorPoint"
        ></div>

        <contentTitle
          text='弘知校区'
          style="margin: 30px 0 30px 0;"
        />
        <div
          class="explain-box"
          v-for="(item,index) in campusData"
          :key="index"
        >
          <div
            style="width: 50%;"
            :class="{ odd: index % 2 != 1, ml20: index % 2 != 0 }"
          >
            <div
              class="ff-pb"
              style="position:relative;font-size:26px;"
            >
              {{item.campusName}}
              <div
                class=""
                style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"
              ></div>
            </div>

            <div style="margin-top: 30px;line-height: 32px;letter-spacing: 1px;min-height:256px;">{{item.campusDesc}}</div>

          </div>

          <img
            class="scaleImg_hover br-r6"
            :class="{ ml20: index % 2 != 1,mr20: index % 2 != 0 }"
            style="width: 480px;height: 270px;object-fit: cover;"
            :src="item.campusPic"
            alt=""
          >
        </div>

        <!-- <div class="explain-box">
                <div style="width: 50%;padding: 0 40px;">
                  <div class="" style="position:relative;font-size:26px;font-weight: bold;">
                    青竹湖校区
                    <div class="" style="position:absolute;width: 32px;height:2px;background-color: #0050A7;bottom: -25%;"></div>
                  </div>
        
                  <div style="margin-top: 30px;font-size: 16px;line-height: 32px;letter-spacing: 1px;;">弘知教育，响应民办教育培训规范化发展要求，打造高标准线下校区，目前拥有四所千平校区———梅溪湖总校、立信旗舰校、青竹湖校区、一中校区，一个教学点———长本校区，总部及线上运营中心坐落于长沙市教育文化发展中心梅溪湖。秉承”让每个学生更高效地学习“这一教学理念，为14-18岁学生提供初高中全学科的线下辅导培训，初高中物理、初中语文的线上AI智能体系及全科线上课程。</div>
        
                </div>
        
                <div style="width: 50%;">
                  <img style="width: 100%;" src="../assets/home-demo.png" alt="">
                </div>
            </div> -->

      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import { campusList } from "@/request/api";
import contentTitle from "@/components/contentTitle.vue";
import Timeline from "@/components/Timeline.vue";
export default {
  name: "about",
  components: {
    NavBar,
    Footer,
    contentTitle,
    Timeline,
  },
  data() {
    return {
      content_control: "1", // 1为企业简介，2为发展历程，3为弘知校区
      tabData: [
        { name: "企业简介", status: true },
        { name: "发展历程", status: false },
        { name: "弘知校区", status: false },
      ],
      navIndexs: "2-1",
      campusData: [], // 校区数据
      vdaH: 0,
    };
  },
  created() {
    this.fetchData();
    this.vdaH = this.clientHeight();
  },
  mounted() {
    let that = this;

    // 获取校区数据
    campusList().then((res) => {
      console.log(res.data.data);
      that.campusData = res.data.data;
    });

    // console.log(this.$route.query)
    let obj = this.$route.query;
    let data = that.tabData;
    data.forEach(function (res, index) {
      if (res.name === obj.type) {
        res.status = true;
      } else {
        res.status = false;
      }
    });
    // console.log("22",data)
    that.tabData = data;
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      // console.log("路由发送变化doing...");
      let that = this;
      // console.log(this.$route.query)
      let obj = this.$route.query;
      let data = that.tabData;
      data.forEach(function (res, index) {
        if (res.name === obj.type) {
          res.status = true;
        } else {
          res.status = false;
        }
      });
      // console.log("22",data)
      that.tabData = data;
      if (obj.type === "企业简介") {
        that.content_control = "1";
        that.navIndexs = "2-1";
      } else if (obj.type === "发展历程") {
        that.content_control = "2";
        that.navIndexs = "2-2";
      } else if (obj.type === "弘知校区") {
        that.content_control = "3";
        that.navIndexs = "2-3";
      }
    },
    selectContent(e, index) {
      this.scrollIntoView(e);

      let that = this;

      if (e === "企业简介") {
        that.content_control = "1";
        that.navIndexs = "2-1";
      } else if (e === "发展历程") {
        that.content_control = "2";
        that.navIndexs = "2-2";
      } else if (e === "弘知校区") {
        that.content_control = "3";
        that.navIndexs = "2-3";
      }

      let data = that.tabData;
      data.forEach(function (res, index) {
        res.status = false;
      });
      data[index].status = true;
      // console.log(data)
      that.tabData = data;
    },
  },
};
</script>

<style scoped>
.content-title-box {
  position: relative;
  font-size: 38px;
  font-weight: bold;
  text-align: center;
}
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #0050a7;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}

.select-tab {
  width: 200px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  margin: 0 40px;
}
.select-tab-true {
  color: #0053ad;
  font-weight: bold;
}
.select-tab-false {
  color: #333333;
  font-weight: bold;
}
.select-tab:hover {
  color: #0053ad;
}

.content-big-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 30px 0 70px;
  background-color: #f7f7f7;
  box-sizing: border-box;
}
.content-box {
  display: flex;
  width: 570px;
  background-color: #fff;

  margin: 10px;
}
.content-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}
.content-img {
  flex-shrink: 0;
  width: 210px;
  height: 210px;
  background-color: #ccc;
}
.content-text-box {
  padding: 20px 15px;
}
.content-title {
  font-size: 20px;
  font-weight: bold;
}
.content-text {
  margin-top: 10px;
  line-height: 28px;
  font-size: 14px;
}

.explain-box {
  width: 1200px;
  background-color: #fff;
  margin: 20px auto 0;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.explain-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

.odd {
  order: 5;
  padding-right: 20px;
}

.ml20 {
  margin-left: 40px;
}

.mr20 {
  margin-right: 20px;
}

.buildImg {
  height: 260px;
  width: 426px;
}

.buildImg2 {
  margin-left: 22px;
}

.buildImg1 {
  margin-right: 22px;
}
</style>
    